/**
 * Created by edgar.torosyan on 3/1/17.
 */
export var LayoutPart;
(function (LayoutPart) {
    LayoutPart["HEADER"] = "header";
    LayoutPart["CONTENT"] = "content";
    LayoutPart["FOOTER"] = "footer";
})(LayoutPart || (LayoutPart = {}));
//# sourceMappingURL=layout.part.enum.js.map